const sizeClasses = {
  'extra-tiny': 'size-1.5',
  tiny: 'size-3',
  'extra-small': 'size-4',
  small: 'size-5',
  medium: 'size-6',
  regular: 'size-8',
  large: 'size-10',
  'extra-large': 'size-12',
  'extra-extra-large': 'size-16',
} as const;

type IconSize = keyof typeof sizeClasses;

export { sizeClasses };
export type { IconSize };
